"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./WebsiteDevelopmentServicesCardSection.module.css";
import webServicesData from "../../data/website-development";
import ServiceCard from "../../components/ServiceCard";

export default function ServicesCardSection({ dynamicData }) {
  const { data: backendPageData } = useServiceData();

  // Requirement 4: dynamicData (from dispatcher) || backendPageData (global fetch) || static fallback
  const services = dynamicData || backendPageData?.services;
  const displayData = (services?.items && services.items.length > 0) ? services.items : webServicesData;

  return (
    <section className={`py-5 ${styles.section}`}>
      <div className="container">
        {/* Section Heading */}
        <div
          className={`text-center mb-5 ${styles.heading}`}
          data-reveal="fade"
        >
          <span className={styles.eyebrow}>{services?.title || "Services"}</span>
          <h2 className={styles.title}>{services?.subtitle || "Customized Web Development Services for Your Success"}</h2>
        </div>

        {/* Cards Grid */}
        <div className="row g-4" data-reveal="stagger-mix">
          {displayData.map((service, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <ServiceCard {...service} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
